/**
 * @generated SignedSource<<a0d54cae6d3c227c7f8fd3c824714686>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useUserDetailRelayQuery$variables = {
  id: string;
};
export type useUserDetailRelayQuery$data = {
  readonly getUser: {
    readonly authStatus: number | null | undefined;
    readonly autoGenNumber: boolean;
    readonly charges: ReadonlyArray<{
      readonly amount: number | null | undefined;
      readonly amountRefunded: number | null | undefined;
      readonly chargeTotal: any | null | undefined;
      readonly created: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly refundStatus: string | null | undefined;
      readonly refunded: boolean | null | undefined;
      readonly status: string | null | undefined;
      readonly taxAmount: any | null | undefined;
      readonly taxRate: any | null | undefined;
    }>;
    readonly createdOn: any | null | undefined;
    readonly creditCards: ReadonlyArray<any> | null | undefined;
    readonly deletedOn: any | null | undefined;
    readonly delinquent: boolean | null | undefined;
    readonly email: string | null | undefined;
    readonly errorReports: ReadonlyArray<{
      readonly closedDate: any | null | undefined;
      readonly content: string | null | undefined;
      readonly created: any | null | undefined;
      readonly hardwareOldId: string | null | undefined;
      readonly id: string;
      readonly notes: string | null | undefined;
      readonly oldId: string | null | undefined;
      readonly owner: string | null | undefined;
      readonly rentalOldId: string | null | undefined;
      readonly state: number | null | undefined;
      readonly subtype: string | null | undefined;
      readonly systemOldId: string | null | undefined;
      readonly tags: ReadonlyArray<string> | null | undefined;
      readonly type: number | null | undefined;
    }>;
    readonly firstName: string;
    readonly fullName: string | null | undefined;
    readonly id: string;
    readonly language: string | null | undefined;
    readonly lastName: string;
    readonly latestDevice: {
      readonly appVersion: string | null | undefined;
      readonly brand: string | null | undefined;
      readonly carrier: string | null | undefined;
      readonly manufacturer: string | null | undefined;
      readonly model: string | null | undefined;
      readonly os: string | null | undefined;
      readonly osVersion: string | null | undefined;
    } | null | undefined;
    readonly organizationIds: ReadonlyArray<string> | null | undefined;
    readonly phone: string;
    readonly region: string;
    readonly rentals: ReadonlyArray<{
      readonly chargeAmount: number | null | undefined;
      readonly completed: boolean | null | undefined;
      readonly createdOn: any | null | undefined;
      readonly duration: number | null | undefined;
      readonly endBy: any | null | undefined;
      readonly endLocation: {
        readonly id: string;
        readonly name: string;
        readonly oldId: string | null | undefined;
      } | null | undefined;
      readonly endTime: any | null | undefined;
      readonly hardware: {
        readonly hardwareType: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly number: number | null | undefined;
        readonly oldId: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly oldId: string | null | undefined;
      readonly startLocation: {
        readonly id: string;
        readonly name: string;
        readonly oldId: string | null | undefined;
      } | null | undefined;
      readonly startTime: any | null | undefined;
      readonly system: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly oldId: string | null | undefined;
      } | null | undefined;
    }>;
    readonly rfidCards: ReadonlyArray<{
      readonly archivedOn: any | null | undefined;
      readonly cardId: string;
      readonly createdOn: any;
      readonly id: string;
      readonly isActive: boolean | null | undefined;
      readonly label: string | null | undefined;
    }>;
    readonly systemIds: ReadonlyArray<string> | null | undefined;
    readonly userMemberships: ReadonlyArray<{
      readonly approvedOn: any | null | undefined;
      readonly canceledOn: any | null | undefined;
      readonly createdOn: any;
      readonly expiresOn: any | null | undefined;
      readonly id: string;
      readonly isActive: boolean | null | undefined;
      readonly isApproved: boolean | null | undefined;
      readonly isCanceled: boolean | null | undefined;
      readonly isExpired: boolean | null | undefined;
      readonly isRejected: boolean | null | undefined;
      readonly membership: {
        readonly archivedOn: any | null | undefined;
        readonly authType: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly oldId: string | null | undefined;
        readonly systemId: string | null | undefined;
        readonly systemOldId: string | null | undefined;
      } | null | undefined;
      readonly membershipOldId: string;
      readonly oldId: string | null | undefined;
      readonly priority: number;
      readonly rejectedOn: any | null | undefined;
    }>;
    readonly userSystems: ReadonlyArray<{
      readonly acceptedTosOn: any | null | undefined;
      readonly amountDue: number | null | undefined;
      readonly blacklisted: boolean | null | undefined;
      readonly hidden: boolean | null | undefined;
      readonly id: string;
      readonly joined: any | null | undefined;
      readonly organizationId: string | null | undefined;
      readonly rejected: boolean | null | undefined;
      readonly removed: boolean | null | undefined;
      readonly systemId: string | null | undefined;
    }>;
    readonly userWallets: ReadonlyArray<{
      readonly balance: number | null | undefined;
      readonly currency: string;
      readonly id: string;
      readonly partnerOldId: number;
      readonly paymentProvider: string;
    }>;
    readonly walletTransactions: ReadonlyArray<{
      readonly amount: number | null | undefined;
      readonly amountRefunded: number | null | undefined;
      readonly chargeTotal: number | null | undefined;
      readonly createdOn: any;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly oldId: string | null | undefined;
      readonly refunded: boolean | null | undefined;
      readonly taxAmount: any | null | undefined;
      readonly taxRate: any | null | undefined;
      readonly type: string | null | undefined;
    }>;
  } | null | undefined;
};
export type useUserDetailRelayQuery = {
  response: useUserDetailRelayQuery$data;
  variables: useUserDetailRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedOn",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delinquent",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authStatus",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "region",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationIds",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemIds",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoGenNumber",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditCards",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appVersion",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "os",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "osVersion",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carrier",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "brand",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manufacturer",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSystem",
  "kind": "LinkedField",
  "name": "userSystems",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blacklisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "joined",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "acceptedTosOn",
      "storageKey": null
    },
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountDue",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivedOn",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "RfidCard",
  "kind": "LinkedField",
  "name": "rfidCards",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    (v27/*: any*/),
    (v28/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemOldId",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "UserMembership",
  "kind": "LinkedField",
  "name": "userMemberships",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approvedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canceledOn",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejectedOn",
      "storageKey": null
    },
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isApproved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCanceled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExpired",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRejected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipOldId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Membership",
      "kind": "LinkedField",
      "name": "membership",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v30/*: any*/),
        (v31/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authType",
          "storageKey": null
        },
        (v28/*: any*/),
        (v25/*: any*/),
        (v32/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "UserWallet",
  "kind": "LinkedField",
  "name": "userWallets",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "balance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentProvider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partnerOldId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "kind": "Literal",
  "name": "limit",
  "value": 50
},
v36 = [
  (v35/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      {
        "field": "CREATED_ON",
        "order": "DESC"
      }
    ]
  }
],
v37 = [
  (v2/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/)
],
v38 = {
  "alias": null,
  "args": (v36/*: any*/),
  "concreteType": "Rental",
  "kind": "LinkedField",
  "name": "rentals",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v30/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chargeAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Hardware",
      "kind": "LinkedField",
      "name": "hardware",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v30/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HardwareType",
          "kind": "LinkedField",
          "name": "hardwareType",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v31/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "startLocation",
      "plural": false,
      "selections": (v37/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "endLocation",
      "plural": false,
      "selections": (v37/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "System",
      "kind": "LinkedField",
      "name": "system",
      "plural": false,
      "selections": (v37/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": "rentals(limit:50,sort:[{\"field\":\"CREATED_ON\",\"order\":\"DESC\"}])"
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountRefunded",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeTotal",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refunded",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxAmount",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxRate",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": (v36/*: any*/),
  "concreteType": "WalletTransaction",
  "kind": "LinkedField",
  "name": "walletTransactions",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v30/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v41/*: any*/),
    (v7/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/)
  ],
  "storageKey": "walletTransactions(limit:50,sort:[{\"field\":\"CREATED_ON\",\"order\":\"DESC\"}])"
},
v48 = [
  (v35/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      {
        "field": "CREATED",
        "order": "DESC"
      }
    ]
  }
],
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": (v48/*: any*/),
  "concreteType": "Charge",
  "kind": "LinkedField",
  "name": "charges",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v41/*: any*/),
    (v49/*: any*/),
    (v42/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "refundStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/)
  ],
  "storageKey": "charges(limit:50,sort:[{\"field\":\"CREATED\",\"order\":\"DESC\"}])"
},
v51 = {
  "alias": null,
  "args": (v48/*: any*/),
  "concreteType": "SupportTicket",
  "kind": "LinkedField",
  "name": "errorReports",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    (v49/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtype",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hardwareOldId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rentalOldId",
      "storageKey": null
    },
    (v32/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    }
  ],
  "storageKey": "errorReports(limit:50,sort:[{\"field\":\"CREATED\",\"order\":\"DESC\"}])"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserDetailRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "getUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "latestDevice",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          (v26/*: any*/),
          (v29/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v38/*: any*/),
          (v47/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserDetailRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "getUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "latestDevice",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v26/*: any*/),
          (v29/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v38/*: any*/),
          (v47/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "14d939880a1d6b5b36c204fb19f2f804",
    "id": null,
    "metadata": {},
    "name": "useUserDetailRelayQuery",
    "operationKind": "query",
    "text": "query useUserDetailRelayQuery(\n  $id: ID!\n) {\n  getUser(id: $id) {\n    id\n    phone\n    firstName\n    lastName\n    fullName\n    createdOn\n    deletedOn\n    delinquent\n    authStatus\n    language\n    region\n    organizationIds\n    systemIds\n    email\n    autoGenNumber\n    creditCards\n    latestDevice {\n      appVersion\n      model\n      os\n      osVersion\n      carrier\n      brand\n      manufacturer\n      id\n    }\n    userSystems {\n      id\n      blacklisted\n      hidden\n      joined\n      rejected\n      removed\n      acceptedTosOn\n      systemId\n      organizationId\n      amountDue\n    }\n    rfidCards {\n      id\n      cardId\n      label\n      isActive\n      archivedOn\n      createdOn\n    }\n    userMemberships {\n      id\n      oldId\n      approvedOn\n      canceledOn\n      createdOn\n      expiresOn\n      rejectedOn\n      isActive\n      isApproved\n      isCanceled\n      isExpired\n      isRejected\n      priority\n      membershipOldId\n      membership {\n        id\n        oldId\n        name\n        authType\n        archivedOn\n        systemId\n        systemOldId\n      }\n    }\n    userWallets {\n      id\n      balance\n      currency\n      paymentProvider\n      partnerOldId\n    }\n    rentals(limit: 50, sort: [{field: CREATED_ON, order: DESC}]) {\n      id\n      oldId\n      createdOn\n      completed\n      duration\n      chargeAmount\n      startTime\n      endTime\n      endBy\n      hardware {\n        id\n        oldId\n        number\n        hardwareType {\n          id\n          name\n        }\n      }\n      startLocation {\n        id\n        oldId\n        name\n      }\n      endLocation {\n        id\n        oldId\n        name\n      }\n      system {\n        id\n        oldId\n        name\n      }\n    }\n    walletTransactions(limit: 50, sort: [{field: CREATED_ON, order: DESC}]) {\n      id\n      oldId\n      amount\n      amountRefunded\n      chargeTotal\n      createdOn\n      description\n      type\n      refunded\n      taxAmount\n      taxRate\n    }\n    charges(limit: 50, sort: [{field: CREATED, order: DESC}]) {\n      id\n      amount\n      amountRefunded\n      chargeTotal\n      created\n      description\n      refundStatus\n      status\n      refunded\n      taxAmount\n      taxRate\n    }\n    errorReports(limit: 50, sort: [{field: CREATED, order: DESC}]) {\n      id\n      oldId\n      content\n      created\n      closedDate\n      state\n      type\n      subtype\n      notes\n      owner\n      hardwareOldId\n      rentalOldId\n      systemOldId\n      tags\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c711db22c45cb72c48929dab95be3f06";

export default node;
